import { createSelector } from '@reduxjs/toolkit';
import { selectCurrentTab, selectTabByPath, selectTabs } from '.';

export const selectFlagsByPath = (path: string) =>
  createSelector(selectTabByPath(path), (tab) => tab?.flags);

export const selectHistoryByPath = (path: string) =>
  createSelector(selectTabByPath(path), (tab) => tab?.history);

export const selectActiveTabHistoryActions = createSelector(
  selectCurrentTab,
  (tab) => {
    const canUndo = tab?.history ? tab.history.active > 0 : false;

    const canRedo = tab?.history
      ? tab.history.active < tab.history.stack.length - 1
      : false;

    return { canUndo, canRedo };
  },
);

export const selectAllTabsByType = (type: string) =>
  createSelector(selectTabs, (tabs) => tabs.filter((tab) => tab.type === type));

// export const selectWebformNodes = (path: string) =>
//   createSelector(selectTabByPath(path), (tab) => tab?.content);
